import Box from '@/components/UI/box/Box';
import styles from './NeighbourhoodsList.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { FC, useEffect, useState } from 'react';
import { fetchNeighbourhoods } from '@/redux/store/actions/search';
import Button from '@/components/UI/button/Button';
import NeighbourhoodsListSkeleton from './neighbourhoodsListSkeleton/NeighbourhoodsListSkeleton';
import TextField from '@/components/UI/textField/TextField';
import NeighbourhoodsItems from './neighbourhoodsItems/NeighbourhoodsItems';
import NeighbourhoodsEmptyState from './neighbourhoodsEmptyState/NeighbourhoodsEmptyState';
import { Control, SubmitHandler, UseFormHandleSubmit, UseFormSetValue } from 'react-hook-form';
import { NeighbourhoodsData } from '../MidTermNeighbourhoods';
interface NeighbourhoodsListProps {
  handleClose: () => void;
  handleSubmit: UseFormHandleSubmit<NeighbourhoodsData>;
  onSubmit: SubmitHandler<NeighbourhoodsData>;
  handleResetFilter: (e: any) => void;
  control: Control<NeighbourhoodsData>;
  handleValue: UseFormSetValue<NeighbourhoodsData>;
}
const NeighbourhoodsList: FC<NeighbourhoodsListProps> = ({
  handleClose,
  control,
  handleSubmit,
  onSubmit,
  handleResetFilter,
  handleValue
}) => {
  const dispatch = useDispatch();
  const {
    loading,
    data
  } = useSelector(state => state.neighbourhoodsReducer);
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    if (!data?.list || searchText) dispatch(fetchNeighbourhoods(searchText));
  }, [searchText]);
  const handleCloseAndReset = () => {
    handleClose();
    setSearchText('');
  };
  const handleClear = () => {
    setSearchText('');
  };
  return <Box className={styles['neighbourhoods-list-container']} data-sentry-element="Box" data-sentry-component="NeighbourhoodsList" data-sentry-source-file="NeighbourhoodsList.tsx">
      <Box className={styles['neighbourhoods-header']} data-sentry-element="Box" data-sentry-source-file="NeighbourhoodsList.tsx">
        <Box onClick={handleCloseAndReset} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="NeighbourhoodsList.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="NeighbourhoodsList.tsx" />
        </Box>
        <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="NeighbourhoodsList.tsx">انتخاب محله</Typography>
      </Box>

      <form id="hook-form" className={styles['neighbourhoods-form-container']} onSubmit={handleSubmit(onSubmit)}>
        <TextField label="جستجوی محله" onClear={handleClear} onChange={e => {
        setSearchText(e.target.value);
      }} value={searchText} className={styles['search-neighbourhoods']} data-sentry-element="TextField" data-sentry-source-file="NeighbourhoodsList.tsx" />

        {!loading ? <Box className={styles['neighbourhoods-list-section']}>
            {data?.list?.length === 0 || searchText && data?.searchList?.length === 0 ? <NeighbourhoodsEmptyState /> : searchText ? <NeighbourhoodsItems control={control} data={data?.searchList} handleValue={handleValue} /> : <NeighbourhoodsItems control={control} data={data?.list} handleValue={handleValue} />}
          </Box> : <NeighbourhoodsListSkeleton />}
        <Box className={styles['action-footer']} data-sentry-element="Box" data-sentry-source-file="NeighbourhoodsList.tsx">
          <Button format="outlined" onClick={handleResetFilter} data-sentry-element="Button" data-sentry-source-file="NeighbourhoodsList.tsx">
            پاک کردن{' '}
          </Button>

          <Button format="primary" size="medium" type="submit" data-sentry-element="Button" data-sentry-source-file="NeighbourhoodsList.tsx">
            اعمال فیلتر
          </Button>
        </Box>
      </form>
    </Box>;
};
export default NeighbourhoodsList;